import React, { useState, useRef, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate, Link } from "react-router-dom";

import Messages from "../../../constants/Messages";
import { useShowAlert } from "../../../context/AlertContext";
import { useAuth } from "../../../context/AuthProvider";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import { ChevronLeftIcon } from "../../../constants/Icons";

const VerifyResetAccountOtp = () => {
  const { handleLogin } = useAuth();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const navigate = useNavigate();
  const location = useLocation();

  const verifyToken = location.state?.verifyToken;
  const email = location.state?.email;
  const label = location.state?.label;
  const isfrom = location.state?.isfrom;

  const otpInputRef = useRef(null);
  const [isVerifyData, setVerifyData] = useState({ verifycode: "" });
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isResendBtnLoading, setResendBtnLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    if (!verifyToken || !email) {
      navigate("/reset-account", {
        replace: true,
        state: {
          email,
        },
      });
    }
  }, [verifyToken, email, navigate]);

  const validateForm = () => {
    const errors = {};

    if (
      isVerifyData.verifycode === undefined ||
      isVerifyData.verifycode === null ||
      isVerifyData.verifycode === ""
    ) {
      errors.verifycode = Messages.AUTH.OTP_REQUIRED;
    } else if (isVerifyData.verifycode.length !== 6) {
      errors.verifycode = Messages.AUTH.OTP_INVALID;
    }

    setErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];

      switch (firstErrorField) {
        case "verifycode":
          otpInputRef.current?.focus();
          break;
        default:
          break;
      }
    }

    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue =
      name === "verifycode" ? value.replace(/[^0-9]/g, "") : value.trim();
    const updatedData = {
      ...isVerifyData,
      [name]: cleanedValue,
    };
    setVerifyData(updatedData);
  };

  const handleVerifyOTP = async () => {
    setErrorMsg(null);

    if (!validateForm()) return;

    if (!verifyToken) {
      setErrorMsg("OTP verification session has expired. Please try again.");
      return;
    }

    setBtnLoading(true);

    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.post("/module/store/verify-otp", {
        otp: isVerifyData.verifycode,
        verifyToken: verifyToken,
      });

      if (response.status === 200 && response.data?.results) {
        showAlert(
          "success",
          response.data?.message || "Account reset successfully.",
        );

        navigate("/dashboard", {
          replace: true,
        });
      }
    } catch (error) {
      const apiMessage =
        error.response?.data?.message ||
        Messages.AUTH.OTP_FAILED ||
        "Cannot reset account.";

      setErrorMsg(apiMessage);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleVerifyOTP();
    }
  };

  return (
    <div class="wrapper">
      <div class="authentication-reset-password d-flex align-items-center justify-content-center">
        <div class="container">
          <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
            <div class="col mx-auto">
              <div class="card">
                <div class="card-body">
                  <div class="p-4">
                    <div class="mb-4 text-center">
                      <img
                        src="assets/images/logo-icon.png"
                        width="60"
                        alt=""
                      />
                    </div>
                    <div class="text-start mb-4">
                      <h4 className="text-center mt-5 fw-400">
                        OTP Verification
                      </h4>
                      <p className="text-center mb-0">One Time Password</p>
                      <p className="text-center text-success mb-0">
                        (OTP) has been sent successfully to
                      </p>
                      <p className="text-center mb-4"> {email} </p>
                    </div>
                    <div className="row g-3">
                      <div className="col-12">
                        <label htmlFor="verifycode" className="form-label">
                          OTP
                          <span className="text-danger"> *</span>
                        </label>
                        {/* <label
                          htmlFor="verifycode"
                          className="form-label text-right"
                        >
                          {isResendBtnLoading ? (
                            <button
                              className="btn btn-sm bg-label-send shadow-none pb-0 pt-1"
                              disabled
                            >
                              <CircularProgress
                                size={18}
                                className="text-white"
                              />
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={handleResendOTP}
                              className="btn btn-sm bg-label-send shadow-none"
                            >
                              Resend OTP
                            </button>
                          )}
                        </label> */}
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          value={isVerifyData.verifycode}
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          name="verifycode"
                          pattern="[0-9]*"
                          inputMode="numeric"
                          maxLength="6"
                          ref={otpInputRef}
                          onKeyDown={handleKeyDown}
                        />
                        {error.verifycode && (
                          <div className="invalid-feedback d-block">
                            {error.verifycode}
                          </div>
                        )}
                      </div>

                      {errorMsg && (
                        <div className="invalid-feedback">{errorMsg}</div>
                      )}

                      <div className="col-12">
                        <div className="d-grid">
                          {isBtnLoading ? (
                            <button className="btn btn-primary pb-0" disabled>
                              <CircularProgress
                                size={22}
                                className="text-white"
                              />
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={handleVerifyOTP}
                              className="btn btn-primary"
                            >
                              Reset Account
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="text-center">
                          <Link
                            to="/reset-account"
                            state={{
                              email,
                            }}
                            className="d-flex align-items-center justify-content-center text-decoration-none"
                          >
                            <ChevronLeftIcon iClass={"me-1 fs-18"}/>
                            Back to Reset
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyResetAccountOtp;
